import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

const CostCenterAssignmentsPreview = () => {
  return (
    <Box justifyContent="center" alignItems="center" gap="s12" flexGrow>
      <OneEmptyState
        emoji="✍️"
        title={i18n.t('finance.cost_centers_structure.preview.empty.assignments.title')}
        description={i18n.t('finance.cost_centers_structure.preview.empty.assignments.description')}
      />
    </Box>
  )
}

export { CostCenterAssignmentsPreview }
